import { PropertyWizardContext } from 'context/Context';
import { Form as FormFormik, Formik } from 'formik';
import { useContext, useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

const getInitialExtras = (extras, values) => {
  const initialExtras = {};

  extras.forEach(category => {
    if (!initialExtras[category.key]) initialExtras[category.key] = {};
    category.extras.forEach(extra => {
      if (!values[category.key]) {
        initialExtras[category.key][extra.key] = false;
      } else {
        initialExtras[category.key][extra.key] =
          values[category.key][extra.key] || false;
      }
    });
  });

  return initialExtras;
};

const Extras = () => {
  const { data, handleSubmit, setStepStatus, yupSubmitRef, form } = useContext(
    PropertyWizardContext
  );

  const extras = form.extras;

  return (
    <div>
      <Formik
        initialValues={
          extras
            ? {
                ...data,
                extras: getInitialExtras(extras, data.extras || {})
              }
            : {
                ...data
              }
        }
        onSubmit={values => handleSubmit(values)}
      >
        {({ values, setValues }) => {
          //hanlders
          useEffect(() => {
            setStepStatus(prev => ({
              ...prev,
              ...values
            }));
          }, [values]);
          return (
            <FormFormik>
              {extras ? (
                <Row className="g-3">
                  {extras
                    .slice()
                    .sort((a, b) => b.extras.length - a.extras.length)
                    .map(category => (
                      <Col xs={12} md={6} lg={4} key={category.key}>
                        <h5>{category.title}</h5>

                        {category.extras
                          .slice()
                          .sort((a, b) => a.title.localeCompare(b.title))
                          .map(extra => (
                            <Form.Group
                              className="d-flex gap-2 align-items-center"
                              key={extra.key}
                            >
                              <Form.Check
                                type="checkbox"
                                name={extra.key}
                                onChange={e =>
                                  setValues(prev => ({
                                    ...prev,
                                    extras: {
                                      ...prev.extras,
                                      [category.key]: {
                                        ...prev.extras[category.key],
                                        [extra.key]: e.target.checked
                                      }
                                    }
                                  }))
                                }
                                checked={values.extras[category.key][extra.key]}
                              />

                              <Form.Label className="m-0">
                                {extra.title}
                              </Form.Label>
                            </Form.Group>
                          ))}
                      </Col>
                    ))}
                </Row>
              ) : (
                <div className="text-center">
                  <h4>Esta propiedad no tiene extras</h4>
                </div>
              )}
              <button hidden ref={yupSubmitRef}></button>
            </FormFormik>
          );
        }}
      </Formik>
    </div>
  );
};

export default Extras;
